import { createSlice } from '@reduxjs/toolkit';

const reducerName = 'atsDashboardData';
const initialState = {
  tasks: {
    sort: {
      id: 'created_at',
      label: 'Most recent',
      element: 'created_at',
      order: 'desc',
    },
    scorecardTasks: { data: [], meta: {}, isLoading: true },
    jobApprovalTasks: { data: [], meta: {}, isLoading: true },
    offerApprovalTasks: { data: [], meta: {}, isLoading: true },
    surveyTasks: { data: [], meta: {}, isLoading: true },
    requisitionApprovalTasks: { data: [], meta: {}, isLoading: true },
    unifiedApprovalTasks: { data: [], meta: {}, isLoading: true },
  },
  interviews: {
    isLoading: true,
    data: [],
    meta: {},
  },
  activities: {
    currentTab: 'overdue',
    sort: {
      id: 'time_in_stage',
      label: 'Time In stage (Descending)',
      element: 'time_in_stage',
      order: 'desc',
    },
    jobScope: 'my-jobs',
    filters: {
      ats_job_id: [{ id: 'all', name: 'All' }],
    },
    metrics: {
      data: {
        overdue: 0,
        needs_scheduling: 0,
        needs_decision: 0,
        needs_offer: 0,
        needs_action: 0,
      },
      isLoading: false,
    },
    overdue: { data: [], meta: {}, isLoading: false },
    needs_scheduling: { data: [], meta: {}, isLoading: false },
    needs_action: { data: [], meta: {}, isLoading: false },
    needs_decision: { data: [], meta: {}, isLoading: false },
    needs_offer: { data: [], meta: {}, isLoading: false },
  },
};

const { reducer, actions: atsDashboardActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    setActivitiesMetrics: (state, { payload }) => {
      const counts = payload?.counts || {};
      const {
        overdue = 0,
        needs_scheduling = 0,
        needs_action = 0,
        needs_decision = 0,
        needs_offer = 0,
      } = counts;
      state.activities.metrics.data.overdue = overdue;
      state.activities.metrics.data.needs_scheduling = needs_scheduling;
      state.activities.metrics.data.needs_action = needs_action;
      state.activities.metrics.data.needs_decision = needs_decision;
      state.activities.metrics.data.needs_offer = needs_offer;
      state.activities.metrics.isLoading = false;
    },

    setActivitiesTab: (state, { payload }) => {
      state.activities.currentTab = payload;
    },

    setActivitiesLoading: (state) => {
      state.activities.metrics.isLoading = true;
      state.activities[state.activities.currentTab].isLoading = true;
    },

    setActivities: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.activities[state.activities.currentTab].data = data;
      state.activities[state.activities.currentTab].meta = meta;
      state.activities[state.activities.currentTab].isLoading = false;
    },

    applyActivitiesFilter: (state, { payload }) => {
      const { key, value } = payload;
      state.activities.filters[key] = value;
    },

    applyActivitiesJobScope: (state, { payload }) => {
      state.activities.jobScope = payload;
      if (payload !== 'specific-jobs') {
        state.activities.filters.ats_job_id = [{ id: 'all', name: 'All' }];
      }
    },

    applyActivitiesSort: (state, { payload }) => {
      state.activities.sort = payload;
    },

    applyTasksSort: (state, { payload }) => {
      state.tasks.sort = payload;
    },

    setTasksLoading: (state, { payload }) => {
      state.tasks.jobApprovalTasks.isLoading = true;
      state.tasks.offerApprovalTasks.isLoading = true;
      state.tasks.scorecardTasks.isLoading = true;
      state.tasks.surveyTasks.isLoading = true;
      state.tasks.requisitionApprovalTasks.isLoading = true;
      state.tasks.unifiedApprovalTasks.isLoading = true;
    },

    applyScoreCardTasks: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.tasks.scorecardTasks.data = data;
      state.tasks.scorecardTasks.meta = meta;
      state.tasks.scorecardTasks.isLoading = false;
    },

    applyJobApprovalTasks: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.tasks.jobApprovalTasks.data = data;
      state.tasks.jobApprovalTasks.meta = meta;
      state.tasks.jobApprovalTasks.isLoading = false;
    },

    applyOfferApprovalTasks: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.tasks.offerApprovalTasks.data = data;
      state.tasks.offerApprovalTasks.meta = meta;
      state.tasks.offerApprovalTasks.isLoading = false;
    },

    applySurveyTasks: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.tasks.surveyTasks.data = data;
      state.tasks.surveyTasks.meta = meta;
      state.tasks.surveyTasks.isLoading = false;
    },
    applyRequisitionApprovalTasks: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.tasks.requisitionApprovalTasks.data = data;
      state.tasks.requisitionApprovalTasks.meta = meta;
      state.tasks.requisitionApprovalTasks.isLoading = false;
    },

    applyUnifiedApprovalTasks: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.tasks.unifiedApprovalTasks.data = data;
      state.tasks.unifiedApprovalTasks.meta = meta;
      state.tasks.unifiedApprovalTasks.isLoading = false;
    },

    setInterviewsLoading: (state) => {
      state.interviews.isLoading = true;
    },

    setInterviewsData: (state, { payload }) => {
      const { interviews = [], pagination = {} } = payload;
      state.interviews.data = [...interviews];
      state.interviews.meta = pagination;
      state.interviews.isLoading = false;
    },
  },
});

export { atsDashboardActions };
export default reducer;
